import React from 'react'

import { useTiers } from '../../../Perks/hooks/useTiers'
import { useFilterMembers } from '../../hooks/useFilterMembers'
import { MembersFilterView } from './MembersFilterView'
import { FILTER_BILLING_CYCLE_LABELS, FILTER_STATE_LABELS, FILTER_TYPE_LABELS } from './consts'
import type { FilterFormValues, FilterTierLabels } from './types'
import { mapLabelsToCheckboxOptions } from './utils'

export const MembersFilterContainer = () => {
  const { filtersParams, setFiltersParams, resetFiltersParams, hasFilterParams } =
    useFilterMembers()
  const { tiers } = useTiers()

  if (!tiers) {
    return null
  }

  const getFilterStatusLabels = (): FilterTierLabels => {
    const labels: any = {}

    tiers?.forEach((tier) => {
      labels[tier.id] = tier.title
    })

    return labels
  }

  const handleSubmit = (values: FilterFormValues) => {
    setFiltersParams({
      type: values.type.length ? values.type.join(',') : undefined,
      tier: values.tier.length ? values.tier.join(',') : undefined,
      billingCycle: values.billingCycle.length ? values.billingCycle.join(',') : undefined,
      state: values.state.length ? values.state.join(',') : undefined,
      giftedByOthers: values.giftedByOthers,
    })
  }

  const getInitialValues = () => ({
    type: filtersParams.type ? filtersParams.type.split(',') : [],
    tier: filtersParams.tier ? filtersParams.tier.split(',') : [],
    billingCycle: filtersParams.billingCycle ? filtersParams.billingCycle.split(',') : [],
    state: filtersParams.state ? filtersParams.state.split(',') : [],
    giftedByOthers: filtersParams.giftedByOthers ?? false,
  })

  return (
    <MembersFilterView
      initialValues={getInitialValues()}
      types={mapLabelsToCheckboxOptions(FILTER_TYPE_LABELS)}
      tiers={mapLabelsToCheckboxOptions(getFilterStatusLabels())}
      billingCycles={mapLabelsToCheckboxOptions(FILTER_BILLING_CYCLE_LABELS)}
      states={mapLabelsToCheckboxOptions(FILTER_STATE_LABELS)}
      filterActive={hasFilterParams}
      onSubmit={handleSubmit}
      onReset={resetFiltersParams}
    />
  )
}
